var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTraccion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#GradientFill_3-2);\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#GradientFill_3-3);\n      }\n\n      .cls-3 {\n        fill: url(#GradientFill_3);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3",
    "data-name": "GradientFill 3",
    x1: 25,
    y1: 50.01,
    x2: 25,
    y2: 0.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa780c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#d1b24a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5d06a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-2",
    "data-name": "GradientFill 3",
    y1: 50,
    y2: 0,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-3",
    "data-name": "GradientFill 3",
    x1: 25,
    x2: 25,
    xlinkHref: "#GradientFill_3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25,18.17c-3.77,0-6.83,3.06-6.83,6.83s3.06,6.83,6.83,6.83,6.83-3.06,6.83-6.83-3.06-6.83-6.83-6.83ZM25,30.5c-3.04,0-5.5-2.46-5.5-5.5s2.46-5.5,5.5-5.5,5.5,2.46,5.5,5.5-2.46,5.5-5.5,5.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,0C11.22,0,0,11.21,0,25s11.22,25,25,25,25-11.21,25-25S38.78,0,25,0ZM25,46.94c-12.1,0-21.94-9.84-21.94-21.94S12.9,3.06,25,3.06s21.94,9.84,21.94,21.94-9.84,21.94-21.94,21.94Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.44,24.95l-.98.02c0-1.29-.18-2.53-.48-3.72l1.51-.38c-.33-1.33-.83-2.61-1.47-3.83l-1.36.72c-.59-1.1-1.31-2.12-2.14-3.05l1.16-1.04c-.91-1.02-1.95-1.93-3.07-2.71l-.87,1.27c-1.02-.7-2.13-1.27-3.31-1.71l.55-1.46c-1.28-.48-2.62-.81-3.98-.97l-.18,1.54c-.6-.07-1.2-.12-1.81-.12-.65,0-1.28.05-1.91.13l-.19-1.54c-1.36.17-2.7.5-3.98.99l.56,1.45c-1.17.45-2.28,1.03-3.29,1.73l-.88-1.27c-1.12.78-2.15,1.7-3.06,2.72l1.17,1.03c-.82.93-1.53,1.95-2.11,3.06l-1.37-.72c-.64,1.22-1.12,2.51-1.45,3.84l1.51.37c-.29,1.18-.45,2.4-.45,3.66,0,.01,0,.02,0,.03h-1.54c0,1.38.17,2.74.5,4.07l1.51-.37c.3,1.22.74,2.39,1.32,3.48l-1.37.72c.64,1.21,1.42,2.34,2.33,3.36l1.16-1.03c.83.93,1.76,1.77,2.78,2.47l-.88,1.27c1.13.78,2.35,1.42,3.63,1.9l.55-1.46c1.15.43,2.36.74,3.62.89l-.18,1.54c.67.08,1.35.12,2.03.12.69,0,1.38-.04,2.06-.12l-.19-1.54c1.26-.15,2.47-.46,3.61-.9l.55,1.45c1.28-.49,2.5-1.13,3.62-1.91l-.88-1.27c1.03-.71,1.95-1.55,2.78-2.48l1.16,1.03c.91-1.03,1.69-2.16,2.33-3.37l-1.37-.72c.57-1.09,1.01-2.26,1.31-3.48l1.51.37c.33-1.32.49-2.69.49-4.11h-.56ZM25,35.26c-5.67,0-10.26-4.59-10.26-10.26s4.59-10.26,10.26-10.26,10.26,4.59,10.26,10.26-4.59,10.26-10.26,10.26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTraccion);
export default __webpack_public_path__ + "static/media/Icon_Traccion.7e3cdd79eb5a0d46bc108c14d01869c5.svg";
export { ForwardRef as ReactComponent };